export default function setupFaq() {

    const buttons = document.querySelectorAll('.faq-filter__label');
    const categories = document.querySelectorAll('.faq__category');
    const searchInput = document.getElementById('faq-search');

    let activeCategory = 'all';

    buttons.forEach(button => {
        button.addEventListener('click', () => {

            activeCategory = button.dataset.category;

            buttons.forEach(btn => {
                btn.classList.remove('faq-filter__label--selected');
            });

            button.classList.add('faq-filter__label--selected');

            categories.forEach(category => {

                const match =
                    activeCategory === 'all' ||
                    category.dataset.category === activeCategory;

                category.style.display = match ? '' : 'none';

            });

        });
    });

    if (searchInput) {
        searchInput.addEventListener('input', function () {

            const query = this.value.toLowerCase();

            document.querySelectorAll('.faq__category').forEach(category => {

                let hasVisibleItems = false;

                category.querySelectorAll('.faq-toggle').forEach(item => {

                    const question = item.querySelector('.faq-toggle__question')
                        .textContent.toLowerCase();

                    const match = question.includes(query);

                    item.style.display = match ? '' : 'none';

                    if (match) hasVisibleItems = true;

                });

                if (activeCategory !== 'all' && category.dataset.category !== activeCategory) {
                    category.style.display = 'none';
                } else {
                    category.style.display = hasVisibleItems ? '' : 'none';
                }

            });

        });
    }

}
